<div class="sc-text-editor2">
  <!-- input to know if control inside form view and fieldset is disabled-->
  <input scCombo hidden="hidden" />
  <div>
    @if (scLabel) {
      <label class="input-label">
        {{ scLabel }}
        <span class="sc-required sc-required-star"></span>
      </label>
    }
  </div>
  <!-- Display editor value when component is disabled -->
  @if (isDisabled) {
    <div class="sc-text-editor2__content--disabled">
      <span [innerHTML]="editorValue"></span>
    </div>
  }
  <!-- [readOnly]="isDisabled || fieldSetDisabled ? true : false" -->
  @if (!isDisabled) {
    <quill-editor #editorComponent
      [customOptions]="customOptions"
      [format]="editorFormat"
      [maxLength]="scMaxLength"
      [placeholder]="scPlaceholder"
      (onEditorCreated)="onEditorCreated($event)"
      (onEditorChanged)="onEditorChanged($event)"
      (onContentChanged)="onContentChanged($event)"
      (onSelectionChanged)="onSelectionChanged($event)"
      [ngModel]="editorValue"
      (ngModelChange)="onValueChanged($event)"
      >
      <!-- (keydown)="onKeyDown($event)" -->
      <!--<div quill-editor-toolbar>
      <span class="ql-formats">
        <button class="ql-bold" [title]="'Bold'"></button>
        <button class="ql-italic" [title]="'Italic'"></button>
        <button class="ql-underline" [title]="'Underline'"></button>
        <button class="ql-strike" [title]="'Strike'"></button>
      </span>
      <span class="ql-formats" *ngIf="scShowAlignment">
        <select class="ql-align" [title]="'Aligment'">
          <option selected></option>
          <option value="center"></option>
          <option value="right"></option>
          <option value="justify"></option>
        </select>
      </span>
      <span class="ql-formats">
        <select class="ql-color" [title]="'Char color'" *ngIf="scShowFontColor"></select>
        <select class="ql-background" [title]="'Bg color'" *ngIf="scShowTextHighlight"></select>
      </span>
      <select class="ql-font">
        <option value='Calibri'>Calibri</option>
        <option value="Aref">Aref Ruqaa</option>
        <option value="Mirza">Mirza</option>
        <option value='Roboto'>Roboto</option>
        <option value='sans-serif'>Sans Serif</option>
        <option value='monosapce'>Monosapce</option>
        <option value='serif'>Serif</option>
        <option value='Georgia'>Georgia</option>
        <option value='palatino-linotype'>Palatino Linotype</option>
        <option value='times-new-roman'>Times New Roman</option>
        <option value='Arial'>Arial</option>
        <option value='Helvetica'>Helvetica</option>
        <option value='arial-black'>Arial Black</option>
        <option value='comic-sans-ms'>Comic Sans MS</option>
        <option value='Charcoal'>Charcoal</option>
        <option value='Impact'>Impact</option>
        <option value='lucida-sans-unicode'>Lucida Sans Unicode</option>
        <option value='lucida-grande'>Lucida Grande</option>
        <option value='Tahoma'>Tahoma</option>
        <option value='Geneva'>Geneva</option>
        <option value='trebuchet-ms'>Trebuchet MS</option>
        <option value='Verdana' selected>Verdana</option>
        <option value='courier-new'>Courier New</option>
        <option value='lucida-console'>Lucida Console</option>
      </select>
      <span class="ql-format-group">
        <select title="Size" class="ql-size">
          <option value="8pt">8</option>
          <option value="9pt" selected>9</option>
          <option value="10pt">10</option>
          <option value="11pt">11</option>
          <option value="12pt">12</option>
          <option value="14pt">14</option>
          <option value="16pt">16</option>
          <option value="18pt">18</option>
          <option value="20pt">20</option>
          <option value="22pt">22</option>
          <option value="24pt">24</option>
          <option value="26pt">26</option>
          <option value="28pt">28</option>
          <option value="30pt">30</option>
          <option value="32pt">32</option>
          <option value="36pt">36</option>
          <option value="48pt">48</option>
          <option value="72pt">72</option>
        </select>
      </span>
    </div>-->
  </quill-editor>
}
@if (!isDisabled && scMaxLength && scShowTextCount) {
  <div class="allowed-count">
    {{remainingCount}}/{{scMaxLength}}
  </div>
}
</div>

@if (!scHideValidationMessage && !isValid) {
  <p class="sc-error-message">{{validationMessage}}</p>
}
